import { gameRoutes, type GameMeta, type SimpleDate } from '@puzzlio/core';
import { colors } from '@puzzlio/tokens';

/** This game's cross-platform metadata; see GameMeta. */
export const meta: GameMeta = {
  type: 'loopy-river',
  gameId: 4,
  label: 'Loopy River',
  description: 'Draw a single continuous loop around the grid',
  emoji: '🌀',
  buttonColor: 'blue',
  background: { fill: colors['blue-100'], dot: colors['blue-200'] },
  burst: { inner: colors['blue-default'], outer: colors['blue-200'] },
  separator: colors['blue-600'],
  earliestDate: '2026-05-04' as SimpleDate,
  tutorialSlug: 'tutorial-1',
  practiceCollections: [
    { level: 1, puzzles: ['easy-1', 'easy-2', 'easy-3'] },
    { level: 2, puzzles: ['medium-1', 'medium-2', 'medium-3'] },
    { level: 3, puzzles: ['hard-1', 'hard-2', 'hard-3'] },
  ],
  enableHints: true,
  availability: 'available',
  ...gameRoutes('/games/loopy-river'),
};
